import { defineMessages } from 'react-intl';

export const photoSliderMessages = defineMessages({
  videoUnsupportedFormat: {
    id: 'dentalPhotos.video.unsupportedFormat',
    defaultMessage:
      "This video can't be played in your browser. Download it to view.",
  },
  videoPlaybackError: {
    id: 'dentalPhotos.video.playbackError',
    defaultMessage: "Couldn't play this video.",
  },
});
